import { createFeatureSelector } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';

import { BackAuthFeatureKey, IBackAuthState } from './auth/auth.state';
import { BackMiscFeatureKey } from './misc';



import { IBackMiscState } from './misc/misc.reducer';
import { BackPrtgFeatureKey, BackPrtgInitialState, IBackPrtgState } from './prtg/prtg.state';
import { BackPataCopilFeatureKey, BackPataCopilsInitialState, IBackPataCopilsState } from './pata/copils/copils.state';
import { BackItsmFeatureKey, BackItsmInitialState, IBackItsmState } from './itsm/itsm.state';
import { BackBckpFeatureKey, BackBckpInitialState, IBackBckpState } from './bckp/bckp.state';
import { BackEntitiesSelectionFeatureKey, BackEntitiesSelectionInitialState, IBackEntitiesSelectionState } from './entities-selection/entities-selection.state';

export const BackFeatureKey = 'back';

export interface IBackState
{
    [BackAuthFeatureKey]: IBackAuthState;
    [BackMiscFeatureKey]: IBackMiscState;
    [BackPrtgFeatureKey]: IBackPrtgState;
    [BackPataCopilFeatureKey]: IBackPataCopilsState;
    [BackItsmFeatureKey]: IBackItsmState;
    [BackBckpFeatureKey]: IBackBckpState;
    [BackEntitiesSelectionFeatureKey]: IBackEntitiesSelectionState;
}

export interface IState extends IAuroraState
{
    [BackFeatureKey]: IBackState;
}
export const BackInitialState: IBackState = {
    [BackAuthFeatureKey]: null,
    [BackMiscFeatureKey]: null,
    [BackPrtgFeatureKey]: BackPrtgInitialState,
    [BackPataCopilFeatureKey]: BackPataCopilsInitialState,
    [BackItsmFeatureKey]: BackItsmInitialState,
    [BackBckpFeatureKey]: BackBckpInitialState,
    [BackEntitiesSelectionFeatureKey]: BackEntitiesSelectionInitialState
};

export const getBackState = createFeatureSelector<IBackState>(
    BackFeatureKey
);
